export var CreationStatus;
(function (CreationStatus) {
    CreationStatus["Initiated"] = "1";
    CreationStatus["Completed"] = "2";
    CreationStatus["Failed"] = "3";
    CreationStatus["CouldNotInitiate"] = "4";
    CreationStatus["OrderNotFound"] = "5";
})(CreationStatus || (CreationStatus = {}));
export var AssetReferenceType;
(function (AssetReferenceType) {
    AssetReferenceType[AssetReferenceType["ParallelWorkOrderId"] = 2] = "ParallelWorkOrderId";
    AssetReferenceType[AssetReferenceType["ActivityId"] = 3] = "ActivityId";
    AssetReferenceType[AssetReferenceType["IdeSalesOrderDetailsId"] = 4] = "IdeSalesOrderDetailsId";
    AssetReferenceType[AssetReferenceType["Fms_none"] = 5] = "Fms_none";
    AssetReferenceType[AssetReferenceType["Fms_3ds"] = 6] = "Fms_3ds";
    AssetReferenceType[AssetReferenceType["Fms_3dc"] = 7] = "Fms_3dc";
    AssetReferenceType[AssetReferenceType["Fms_3dz"] = 8] = "Fms_3dz";
    AssetReferenceType[AssetReferenceType["Fms_gCode"] = 9] = "Fms_gCode";
    AssetReferenceType[AssetReferenceType["Fms_catalog"] = 10] = "Fms_catalog";
    AssetReferenceType[AssetReferenceType["Fms_images"] = 11] = "Fms_images";
    AssetReferenceType[AssetReferenceType["Fms_3dm"] = 12] = "Fms_3dm";
    AssetReferenceType[AssetReferenceType["Fms_fs3dm"] = 13] = "Fms_fs3dm";
    AssetReferenceType[AssetReferenceType["Fms_evx"] = 14] = "Fms_evx";
    AssetReferenceType[AssetReferenceType["Fms_niri"] = 15] = "Fms_niri";
    AssetReferenceType[AssetReferenceType["Fms_capture"] = 16] = "Fms_capture";
    AssetReferenceType[AssetReferenceType["CaaS_ITR"] = 17] = "CaaS_ITR";
    AssetReferenceType[AssetReferenceType["OrderImageId"] = 19] = "OrderImageId";
    AssetReferenceType[AssetReferenceType["CaaS_IMG"] = 20] = "CaaS_IMG";
    AssetReferenceType[AssetReferenceType["Data_Request"] = 21] = "Data_Request";
    AssetReferenceType[AssetReferenceType["Visit_Report"] = 22] = "Visit_Report";
    AssetReferenceType[AssetReferenceType["TextureMapping"] = 23] = "TextureMapping";
    AssetReferenceType[AssetReferenceType["RxImages"] = 24] = "RxImages";
    AssetReferenceType[AssetReferenceType["Shared3DPreview"] = 25] = "Shared3DPreview";
    AssetReferenceType[AssetReferenceType["XraiImages"] = 26] = "XraiImages";
    AssetReferenceType[AssetReferenceType["Alf"] = 27] = "Alf";
    AssetReferenceType[AssetReferenceType["Fms_Ief_3ds"] = 28] = "Fms_Ief_3ds";
    AssetReferenceType[AssetReferenceType["Fms_xiri"] = 29] = "Fms_xiri";
})(AssetReferenceType || (AssetReferenceType = {}));
export var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes[ErrorCodes["badRequest"] = 400] = "badRequest";
    ErrorCodes[ErrorCodes["unauthorized"] = 401] = "unauthorized";
    ErrorCodes[ErrorCodes["forbidden"] = 403] = "forbidden";
    ErrorCodes[ErrorCodes["notFound"] = 404] = "notFound";
    ErrorCodes[ErrorCodes["requestTimeout"] = 408] = "requestTimeout";
    ErrorCodes[ErrorCodes["tooManyRequests"] = 429] = "tooManyRequests";
    ErrorCodes[ErrorCodes["internalServerError"] = 500] = "internalServerError";
})(ErrorCodes || (ErrorCodes = {}));
//# sourceMappingURL=types.js.map